import { getBackendBaseUrl } from "./apiUrl";

let activeToken = null;

// Registry for callback subscribers
const listeners = {
  "deal:updated": [],
  "kiosk:question-heading": [],
  "kiosk:ai-stream-chunk": [],
  "kiosk:ai-stream-end": [],
  "kiosk:ai-error": [],
  "connect_error": []
};

// Dispatch events to registered callback subscribers
const notifyListeners = (event, data) => {
  if (listeners[event]) {
    listeners[event].forEach((cb) => {
      try { cb(data); } catch (e) { console.error(`[Listener Error for ${event}]:`, e); }
    });
  }
};

// Dummy socket getter for compatibility
export const getSocket = () => {
  return null;
};

// Set Active Deal Session Token
export const joinDealRoom = (token) => {
  if (!token) return;
  const roomToken = token.startsWith("deal:") ? token.replace("deal:", "") : token;
  activeToken = roomToken;
};

// Leave Deal Session
export const leaveDealRoom = (token) => {
  const roomToken = token ? (token.startsWith("deal:") ? token.replace("deal:", "") : token) : activeToken;
  if (activeToken === roomToken || !token) {
    activeToken = null;
  }
};

// Send Step Action via Pure HTTP POST and receive dynamic AI response
export const sendStepAction = async (payload) => {
  const step = payload?.step || 1;
  const act = payload?.actionType || "action";
  const val = typeof payload?.value === "object" ? JSON.stringify(payload.value) : (payload?.value || "");
  const token = payload?.token || activeToken;

  const backendUrl = getBackendBaseUrl();
  console.log("%c[USER ACTION SENT VIA HTTP POST] 📡 Step " + step + " | Action: \"" + act + "\" = \"" + val + "\"", "color: #f59e0b; font-weight: bold; font-size: 12px;");
  
  try {
    const res = await fetch(`${backendUrl}/api/d2-deals/kiosk/step-action`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, token })
    });
    if (res.ok) {
      const data = await res.json();
      if (data.heading) {
        notifyListeners("kiosk:question-heading", { step: data.step || step, heading: data.heading, subheading: data.subheading });
      }
      if (data.chunks && Array.isArray(data.chunks)) {
        data.chunks.forEach((chunk, idx) => {
          notifyListeners("kiosk:ai-stream-chunk", { step: data.step || step, chunk, sequence: idx + 1 });
        });
      }
      notifyListeners("kiosk:ai-stream-end", { step: data.step || step });
    }
  } catch (err) {
    console.error("[HTTP Step Action Failed]:", err.message);
  }
};

/**
 * Update Deal State over WebSocket
 */
export const updateDealOverSocket = (payload) => {
  const token = payload?.token || activeToken;
  const backendUrl = getBackendBaseUrl();

  if (payload?.updates && token) {
    fetch(`${backendUrl}/api/d2-deals/kiosk/update/${encodeURIComponent(token)}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload.updates)
    }).catch((err) => console.warn("[HTTP Update Deal Error]:", err.message));
  }
};

/**
 * Listener: Deal Updated (from backend broadcast)
 */
export const onDealUpdated = (callback) => {
  listeners["deal:updated"] = [callback];
};

/**
 * Listener: Dynamic Question Heading
 */
export const onAIQuestionHeading = (callback) => {
  listeners["kiosk:question-heading"] = [callback];
};

/**
 * Listener: Streaming AI Chunks
 */
export const onAIStreamChunk = (callback) => {
  listeners["kiosk:ai-stream-chunk"] = [callback];
};

/**
 * Listener: AI Streaming Complete
 */
export const onAIStreamEnd = (callback) => {
  listeners["kiosk:ai-stream-end"] = [callback];
};

/**
 * Listener: AI Error
 */
export const onAIError = (callback) => {
  listeners["kiosk:ai-error"] = [callback];
};

/**
 * Listener: Connection Error
 */
export const onConnectError = (callback) => {
  listeners["connect_error"] = [callback];
};

const socketClient = {
  getSocket,
  joinDealRoom,
  leaveDealRoom,
  sendStepAction,
  updateDealOverSocket,
  onDealUpdated,
  onAIQuestionHeading,
  onAIStreamChunk,
  onAIStreamEnd,
  onAIError,
  onConnectError
};

export default socketClient;
